import * as yup from 'yup'
import { getLocalStorage, convertToBoolean } from 'src/utils'
import { getNameSchema, getEmailSchema } from 'src/views/addresses/addressUtils'
import { getAppConfig } from 'config/appConfig'
import {
  getPhoneSchema as getMobilePhoneSchema,
  getOptionalPhoneNumberSchema,
} from 'src/deps'

const schema = isSelfOnBoard => {
  const accType = getLocalStorage('accountType')
  const enableJITSU = convertToBoolean(getAppConfig()?.enableJITSU)

  let schemaData = {}
  if (isSelfOnBoard === false) {
    Object.assign(schemaData)
    if (accType == 'Brand Affiliate - Business Entity') {
      Object.assign(schemaData)
    } else if (accType == 'Brand Affiliate') {
      Object.assign(
        schemaData,
        getEmailSchema({
          inputName: 'email',
        })
      )
    } else {
      Object.assign(
        schemaData,
        getEmailSchema({
          inputName: 'email',
        }),
        getNameSchema({ inputName: 'firstName' }),
        getNameSchema({ isLastName: true, inputName: 'lastName' })
      )
    }

    if (enableJITSU) {
      Object.assign(
        schemaData,
        getOptionalPhoneNumberSchema({ inputName: 'mobilePhoneNumber' })
      )
    } else {
      Object.assign(
        schemaData,
        getMobilePhoneSchema({ inputName: 'mobilePhoneNumber' })
      )
    }
  }
  return yup.object(schemaData)
}

export { schema }
